import { request } from '@/helpers/apiClient'
import { PRODUCTS_CONFIG } from '@/utils/constants/apiConfig/productsConfig'


export const getProductList = (queryParams, searchArr) =>
    request(PRODUCTS_CONFIG.PRODUCT_LIST(queryParams), { data: searchArr })

export const getProductCsvFile = (body, queryParams) => request(PRODUCTS_CONFIG.PRODUCT_CSV_DOWNLOAD(queryParams), { data: body })


